import React from "react";
import { Row, Col } from "antd";
import BarChart from "./../../components/Charts/BarChartContainer";

function Drivers(props) {
  return (
    <Row className="survey_content_container survey_results_container">
      <Col md={{ span: 12, offset: 6 }}>
        <Row>
          <Col md={{ span: 24 }} xs={24}>
            <Row gutter={16}>
              <Col md={24} style={{ marginBottom: "20px" }}>
                <h1 style={{ marginBottom: 0 }}>
                  {props.language === "dk"
                    ? "Transactional Analysis Drivere"
                    : "Transactional Analysis Drivers"}
                </h1>
                <p style={{ fontSize: "18px" }}></p>
              </Col>
              <Col
                md={24}
                style={{ marginBottom: "20px", textAlign: "center" }}
              >
                <p style={{ textAlign: "left", marginBottom: "30px" }}></p>
              </Col>
            </Row>
          </Col>
          <Col md={{ span: 24 }} xs={24}>
            <div
              style={{
                width: "100%",
                marginTop: "-20px",
                marginBottom: "50px",
                borderTop: "1px solid rgba(255, 255, 255, 0.3)"
              }}
            />
          </Col>
          <Col md={24} xs={24}>
            <Row className="gap_box" style={{ marginBottom: "20px" }}>
              <BarChart drivers={props.drivers} />
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Drivers;



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/Drivers.js